import { MODULE_ID } from './constants';
export const SET_PROGRESS = `${MODULE_ID}/SET_PROGRESS`;
export const EXPORT_DATA = `${MODULE_ID}/EXPORT_DATA`;
export const EXPORT_DATA_CANCEL = `${MODULE_ID}/EXPORT_DATA_CANCEL`;
export const EXPORT_DATA_SUCCESS = `${MODULE_ID}/EXPORT_DATA_SUCCESS`;
export const EXPORT_DATA_ERROR = `${MODULE_ID}/EXPORT_DATA_ERROR`;
